export type PlanningObjectiveKindId = 'Estrategico' | 'Tatico' | 'Operacional';

export type PlanningObjectiveKindConfig = {
  id: PlanningObjectiveKindId;
  label: string;
  description: string;
};

export const PLANNING_OBJECTIVE_KINDS: PlanningObjectiveKindConfig[] = [
  {
    id: 'Estrategico',
    label: 'Estratégico',
    description: 'Planejamento de longo prazo — metas, marcos, tarefas e indicadores.',
  },
  {
    id: 'Tatico',
    label: 'Tático',
    description: 'Gestão de médio prazo — metas, marcos e tarefas no ciclo.',
  },
  {
    id: 'Operacional',
    label: 'Operacional',
    description: 'Execução do dia a dia — metas, marcos e tarefas no ciclo.',
  },
];

export function formatPlanningObjectiveKind(kind: string): string {
  return PLANNING_OBJECTIVE_KINDS.find((item) => item.id === kind)?.label ?? kind;
}

export function getPlanningObjectiveKindConfig(kind: string): PlanningObjectiveKindConfig {
  return PLANNING_OBJECTIVE_KINDS.find((item) => item.id === kind) ?? PLANNING_OBJECTIVE_KINDS[0];
}
